<template>
  <div class="">
    <div class="">
      <div class="section">
          <div class="section_image">
            <!--  -->
            <div v-if="imageData[0] != undefined" style="position: relative; width: 12rem!important; height: 12rem;">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(0)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[0]}`"
                @click="clickPreview(imageData[0])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 0)"
                      id="FotoPlaquetadeIdentificacaodomoldePreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotoPlaquetadeIdentificacaodomoldePreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div>
              <p class="title">Plaqueta de Identificação</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div v-if="imageData[1] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(1)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[1]}`"
                @click="clickPreview(imageData[1])"
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 1)"
                      id="iddacamaraquentepreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="iddacamaraquentepreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div>
              <p class="title">ID da Câmara Quente</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div class="image-preview" v-if="imageData[2] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(2)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[2]}`"
                @click="clickPreview(imageData[2])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 2)"
                      id="FotodoLadoDireitoPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodoLadoDireitoPreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div>
              <p class="title">Lado Direito</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div class="image-preview" v-if="imageData[3] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(3)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[3]}`"
                @click="clickPreview(imageData[3])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 3)"
                      id="FotodoLadoEsquerdoPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodoLadoEsquerdoPreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div>
              <p class="title">Lado Esquerdo</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div class="image-preview" v-if="imageData[4] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(4)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[4]}`"
                @click="clickPreview(imageData[4])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 4)"
                      id="FotodaPlacadoLadoMovelPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodaPlacadoLadoMovelPreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div>
              <p class="title">Placa do Lado Móvel</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div class="image-preview" v-if="imageData[5] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(5)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[5]}`"
                @click="clickPreview(imageData[5])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 5)"
                      id="FotodaPlacadoLadoFixoPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodaPlacadoLadoFixoPreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div>
              <p class="title">Placa do Lado Fixo</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div class="image-preview" v-if="imageData[6] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(6)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[6]}`"
                @click="clickPreview(imageData[6])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 6)"
                      id="FotodoLadoSuperiorPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodoLadoSuperiorPreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <div>
              <p class="title">Lado Superior</p>
            </div>
          </div>
          <div class="section_image">
            <!--  -->
            <div class="image-preview" v-if="imageData[7] != undefined" style="position: relative; width: 12rem!important; height: 12rem!important">
              <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(7)">
                  <div class="closeimage"></div>
                </label>
              </div>
              <img
                class="container"
                :src="`${imageData[7]}`"
                @click="clickPreview(imageData[7])"
                alt=""
              />
            </div>
            <div class="image-preview" v-else>
              <div v-if="configInputs==0">
                <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 7)"
                      id="FotodaPlaquetadosistemadeRefrigeraçãoPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodaPlaquetadosistemadeRefrigeraçãoPreview">
                  <div class="palavra1"></div>
                </label>
              </div>
              <div v-else>
                <div class="empty"></div>
              </div>
            </div>
            <!--  -->
            <div class="title-container">
              <p class="title">Plaqueta do Sistema de refrigeração</p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      imageData: [],

      FormDataImages: {
        FotoPlaquetadeIdentificacaodomoldeFile: [],
        IDdaCâmaraQuenteFile: [],
        FotodoLadoDireitoFile: [],
        FotodoLadoEsquerdoFile: [],
        FotodaPlacadoLadoMovelFile: [],
        FotodaPlacadoLadoFixoFile: [],
        FotodoLadoSuperiorFile: [],
        FotodaPlaquetadosistemadeRefrigeraçãoFile: [],
      },
    };
  },

  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesMoldeFechado", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal.fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: 'Baixar',
          showCloseButton: true,
          background: "#fff",
          customClass: {
                    popup: 'preview-modal-popup',
                    image: 'preview-modal-image',
                    confirmButton: 'preview-modal-button'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement('a');
            link.href = base64;
            link.download = 'imagem.jpg'; 
            link.click();
          }
      });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID}`;
        this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_ID;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE != null) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE}`;
        this.FormDataImages.IDdaCâmaraQuenteFile =
          dataQuery.ImagesRRIM[0].IMG_MF_CAM_QUENTE;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO}`;
        this.FormDataImages.FotodoLadoDireitoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_DIREITO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO) {
        this.imageData[3] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO}`;
        this.FormDataImages.FotodoLadoEsquerdoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_ESQUERDO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL != null) {
        this.imageData[4] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL}`;
        this.FormDataImages.FotodaPlacadoLadoMovelFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_MOVEL;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO) {
        this.imageData[5] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO}`;
        this.FormDataImages.FotodaPlacadoLadoFixoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_L_FIXO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR) {
        this.imageData[6] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR}`;
        this.FormDataImages.FotodoLadoSuperiorFile =
          dataQuery.ImagesRRIM[0].IMG_MF_L_SUPERIOR;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF != null) {
        this.imageData[7] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF}`;
        this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile =
          dataQuery.ImagesRRIM[0].IMG_MF_PLA_SIS_REF;
      }
    },

    previewFiles(event, position) {
        const input = event.target;

      if (input.files && input.files[0]) {
        const file = input.files[0];

        // Verifica se o arquivo é do tipo imagem
        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = ""; // Limpa o campo
          return;
        }

        // Atualiza o FormData de acordo com a posição
        switch (position) {
          case 0:
            this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile = file;
            break;
          case 1:
            this.FormDataImages.IDdaCâmaraQuenteFile = file;
            break;
          case 2:
            this.FormDataImages.FotodoLadoDireitoFile = file;
            break;
          case 3:
            this.FormDataImages.FotodoLadoEsquerdoFile = file;
            break;
          case 4:
            this.FormDataImages.FotodaPlacadoLadoMovelFile = file;
            break;
          case 5:
            this.FormDataImages.FotodaPlacadoLadoFixoFile = file;
            break;
          case 6:
            this.FormDataImages.FotodoLadoSuperiorFile = file;
            break;
          case 7:
            this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile = file;
            break;
        }

        // Converte imagem para base64 e exibe no preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData[position] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.FotoPlaquetadeIdentificacaodomoldeFile = [];
          break;
        case 1:
          this.FormDataImages.IDdaCâmaraQuenteFile = [];
          break;
        case 2:
          this.FormDataImages.FotodoLadoDireitoFile = [];
          break;
        case 3:
          this.FormDataImages.FotodoLadoEsquerdoFile = [];
          break;
        case 4:
          this.FormDataImages.FotodaPlacadoLadoMovelFile = [];
          break;
        case 5:
          this.FormDataImages.FotodaPlacadoLadoFixoFile = [];
          break;
        case 6:
          this.FormDataImages.FotodoLadoSuperiorFile = [];
          break;
        case 7:
          this.FormDataImages.FotodaPlaquetadosistemadeRefrigeraçãoFile = [];
          break;
      }
    },
  },
};
</script>

<style scoped>

.swal2-image.original-size-image {
  max-width: 90vw;
  max-height: 80vh;
  width: auto;
  height: auto;
  border-radius: 1rem;
}

.container {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center; 
  border-radius: 1rem;
  border: 2px solid #ccc;
  cursor:pointer;
}

.section {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 52.2rem;
  justify-content: center;
  margin-top: 1rem;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
  word-wrap: break-word;
  width: 90%;
}

.title-container {
  width: 90%;
}

.section_image {
  max-width: 12rem!important;
  display: inline-block;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
}

.palavra {
  max-width: 12rem !important;

}

.palavra1 {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 12rem !important;
  height: 12rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.palavra1:hover{
  background-color: rgb(156, 150, 150);
}



.image-preview {
  position: relative;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

#fotoEmbalagemPreview {
  position: relative;
  z-index: 2;
  border-radius: 1rem;
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.extra-input {
  background-color: rgba(255, 255, 255, 0);
  padding: 0!important;
  height: 1rem!important;
  border: none!important;
  color: var(--font_color);
  font-weight: 600;
  font-family: 'Poppins', 'sans-serif';
}

.container {
  border-radius: 0.8rem!important
}



.empty {
  background-image: url('../../../../../../static/icons/empty-image.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}



</style>
